import { render, staticRenderFns } from "./setting-salary.vue?vue&type=template&id=36e20b02&scoped=true&"
import script from "./setting-salary.vue?vue&type=script&lang=js&"
export * from "./setting-salary.vue?vue&type=script&lang=js&"
import style0 from "./setting-salary.vue?vue&type=style&index=0&id=36e20b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e20b02",
  null
  
)

export default component.exports